import useAuth from '../../auth/authContext';
import { useMutation } from '@tanstack/react-query';
import useApi from '../../api/backendApiContext';
import { OnboardingProgressDto } from '../../user/userApi';
import { useQueryCacheManager } from '../../hooks/useQueryCacheManager';

export const useUpdateOnboardingProgressMutation = () => {
  const {
    state: { user },
  } = useAuth();
  const { userApi } = useApi();
  const queryCacheManager = useQueryCacheManager();
  return useMutation({
    mutationFn: async (onboardingProgress: OnboardingProgressDto) => {
      if (user) {
        return userApi.updateOnboardingProgress(user.userId, onboardingProgress);
      }
    },
    onMutate: (onboardingProgress) => {
      queryCacheManager.updateOnboardingProgress(onboardingProgress);
    },
  });
};
